import React from "react";

const Page5 = ({
  page,
  setPage,
  subTotal,
  taxTotal,
  netTotal,
  approvalStatus,
  handlePrint,
  handleFinalSubmit,
  ItemModal,
  isItemModalOpen,
  currentItem,
  handleSaveItem,
  setIsItemModalOpen,
  Page1,
  Page2,
  Page3,
  Page4
}) => {

  const StatusIndicator = ({ label, done }) => (
    <div className="flex items-center">
      <div className={`w-6 h-6 rounded-full flex items-center justify-center text-white ${done ? 'bg-green-500' : 'bg-gray-300'}`}>
        {done && (
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
          </svg>
        )}
      </div>
      <span className={`ml-3 font-medium ${done ? 'text-gray-700' : 'text-gray-500'}`}>{label}</span>
    </div>
  );

  return (
    <>
      <div id="form-container" className="max-w-4xl mx-auto bg-white rounded-xl shadow-lg p-6 md:p-8 space-y-6">
        {page === 1 && <Page1 />}
        {page === 2 && <Page2 />}
        {page === 3 && <Page3 />}
        {page === 4 && <Page4 />}
        {page === 5 && (
          <>
            <h1 className="text-2xl sm:text-3xl font-bold text-gray-800 border-b pb-4">Summary & Finish (Step 5/5)</h1>
            <div className="space-y-6">
              <div className="p-6 bg-white border rounded-lg shadow-sm">
                <h2 className="text-xl font-semibold text-gray-700 mb-4">Final Totals</h2>
                <div className="space-y-3">
                  <div className="flex justify-between items-center text-lg">
                    <span className="text-gray-600">Subtotal</span>
                    <span className="font-semibold text-gray-800">{subTotal.toFixed(2)}</span>
                  </div>
                  <div className="flex justify-between items-center text-lg">
                    <span className="text-gray-600">Tax Total</span>
                    <span className="font-semibold text-gray-800">{taxTotal.toFixed(2)}</span>
                  </div>
                  <div className="flex justify-between items-center text-2xl font-bold border-t pt-3 mt-3">
                    <span className="text-indigo-600">Net Total</span>
                    <span className="text-indigo-600">{netTotal.toFixed(2)}</span>
                  </div>
                </div>
              </div>
              <div className="p-6 bg-white border rounded-lg shadow-sm">
                <h2 className="text-xl font-semibold text-gray-700 mb-4">Approval Status</h2>
                <div className="flex justify-around items-center">
                  <StatusIndicator label="Prepared" done={approvalStatus.prepared} />
                  <div className="flex-grow h-0.5 bg-gray-200 mx-4"></div>
                  <StatusIndicator label="Checked" done={approvalStatus.checked} />
                  <div className="flex-grow h-0.5 bg-gray-200 mx-4"></div>
                  <StatusIndicator label="Verified" done={approvalStatus.verified} />
                </div>
              </div>
            </div>
            <div className="flex justify-between pt-6 border-t mt-6">
              <button onClick={() => setPage(4)} className="px-6 py-2 bg-gray-600 text-white rounded">Back</button>
              <div className="flex space-x-4">
                <button onClick={handlePrint} className="px-6 py-2 bg-blue-600 text-white font-semibold rounded-md shadow-md hover:bg-blue-700">Print</button>
                <button onClick={() => handleFinalSubmit('draft')} className="px-6 py-2 bg-yellow-500 text-white rounded">Save as Draft</button>
                <button onClick={() => handleFinalSubmit('finished')} className="px-6 py-2 bg-green-600 text-white rounded">Finish & Submit</button>
              </div>
            </div>
          </>
        )}
        <ItemModal isOpen={isItemModalOpen} item={currentItem} onClose={() => setIsItemModalOpen(false)} onSave={handleSaveItem} />
      </div>
      <div id="print-container" className="hidden print:block">
        {/* Printable Invoice will be rendered here */}
      </div>
    </>
  );
};

export default Page5;